import TableReviews from './TableReviews/Table'

export const MainCorrection = () => {
  return <TableReviews />
}
